import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
    getUserReferal,
    getReferredUserActivity
} from "../services/waitlist-service";
import ReferActivities from "./ReferActivities";
import ReferedFriends from "./ReferedFriends";
import { Button, Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { Chart } from "../assets/images/Highlight.png";
import ReactGA from "react-ga4";
import { setAnalyticsEvent } from "../../core/helpers/analytics";


export default function ReferMain() {
     
    const history = useHistory();

    const [isMobile, setIsMobile] = useState(false);
    const [loader, setLoader] = useState(true);
    const [activityLoader, setActivityLoader] = useState(true);
    const [referrals, setReferrals] = useState([]);
    const [activity, setActivity] = useState();

    const handleClick = () =>{
       history.push('/refer')
    }

    useEffect(() => {
        const locationHash = window.location.hash;
      ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
        { process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent(locationHash, `${locationHash}`);
        }
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
        getUserReferal().then((response) => {
            if (!response || !response.success) {
                console.log("err");
            }

            if (response.data && response.data) {
                setLoader(true)
                setReferrals(response.data.referral)
            }
        });
        getReferredUserActivity().then((response) => {
            if (!response || !response.success) {
                return console.log("err");
            }

            if (response.data && response.data) {
                setActivity(response.data)
                setActivityLoader(true)
            }
        });

    }, []);

    return (
        <div className="refer-dashboard">
             {/* <ReferCards  />  */}
            <Row> 
             <Col lg={8} className="refer-row">
            {(loader && referrals && referrals.length) ? (
                <ReferedFriends
                    referrals={referrals}
                    isMobile={isMobile}
                />
            ) : (
                <div className="w-100 mt-5 pt-5 text-center">
                   <h2 className="text-center"> No Referrals yet </h2>
                   <Button onClick={handleClick}>Refer Now</Button>
                </div>
            )}
             </Col>
             <Col lg={4} sm={12} xs={12} md={12} className='side-main'>
                <div className='Side-first'>
                    <img src={Chart} alt="chart-img"/>
                </div>
            </Col>
            </Row>
            {activityLoader && activity && activity.length ? (
                <ReferActivities
                    referralActivity={activity}
                    isMobile={isMobile}
                />
            ) : (
                null
            )}
           
        </div>
        
    );
}
